import React from 'react';
import { StatusTag } from '@innovyze/stylovyze';
import { CircularProgress, Grid } from '@mui/material';
import { SensorStatusWrapper } from './EditSensor.styles';
import { DeviceStatus } from '@Types/sensorDetails.types';

type statusText = 'Ready' | 'Resampling' | 'Unavailable' | 'Checking status';
type colorType =
	| 'positive'
	| 'standard'
	| 'neutral'
	| 'warning'
	| 'danger'
	| 'new';

interface SensorStatusIndicatorProps {
	status: DeviceStatus;
}

const SensorStatusIndicator = (props: SensorStatusIndicatorProps) => {
	const { status }: SensorStatusIndicatorProps = props;

	let text: statusText = 'Ready';
	let color: colorType = 'positive';

	const showProgress = status === DeviceStatus.Resample;
	const showBox =
		status === DeviceStatus.CheckingStatus ||
		status === DeviceStatus.Complete ||
		status === DeviceStatus.Resample ||
		status === DeviceStatus.Unavailable;

	if (status === DeviceStatus.CheckingStatus) {
		text = 'Checking status';
		color = 'neutral';
	}
	if (status === DeviceStatus.Complete) {
		text = 'Ready';
		color = 'positive';
	}
	if (status === DeviceStatus.Resample) {
		text = 'Resampling';
		color = 'warning';
	}
	if (status === DeviceStatus.Unavailable) {
		text = 'Unavailable';
		color = 'danger';
	}

	return (
		<SensorStatusWrapper>
			<Grid container spacing={1}>
				{showProgress && (
					<Grid item>
						<CircularProgress size={18} />
					</Grid>
				)}
				{showBox && (
					<Grid item>
						<StatusTag text={text} color={color} />
					</Grid>
				)}
			</Grid>
		</SensorStatusWrapper>
	);
};

export default SensorStatusIndicator;
